import React, { Component } from 'react';
import MuckTruckClassic from '../Static/mini-dumper.jpg';
import MuckTruckMax from '../Static/muck-truck-max.jpg';
import EMuckTruck from '../Static/e-truck.jpg';
import MuckTruckHMax from '../Static/h-max.jpeg';
import {FormattedMessage} from "react-intl";
import ChangeLocale from "../Components/changeLocale";
import manual from '../Static/manualSk.pdf';

class UsefulMachines extends Component {
	changeStep = (step) => {
		this.props.history.push(step);
	};

	render() {
		const { locale, changeLocale } = this.props;

		return (
			<div style={{ position: 'relative' }}>
				<h2>
					<FormattedMessage id='muckTruck' defaultMesage='MUCK-TRUCK' />
				</h2>
				<ChangeLocale locale={locale} changeLocale={changeLocale} />
				<div className='row justifyContent--space'>
					<div className='subTitle'>
						Muck Truck je jediný originál. Prvý v nápade. Prvý v dizajne.<br/>
						Muck Truck je číslo 1 v mini prepravníkoch na svete.<br/>
						Muck-truck® nastavil štandard, ktorý sa ostatní len napodobňujú.<br/>
						MUCK TRUCK  JE JEDEN STROJ PRE  MNOHO POUŽITÍ.<br/>
						Web: <a href='https://www.mucktruck.com' rel='noopener noreferrer' target='_blank'>https://www.mucktruck.com</a>

						{locale === 'en'
							? (
								<div>
									All manuals here: <a target="_blank" rel='noopener noreferrer' href="https://www.mucktruck.com/manuals/">https://www.mucktruck.com/manuals/</a>
								</div>
							) : (
								<a className='download-button' href={manual} rel='noopener noreferrer' target='_blank'>
									<i className="fa fa-bandcamp" />
									<FormattedMessage id='download' />
								</a>
							)
						}
					</div>
				</div>
				<div className='row justifyContent--center'>
					<div className='product-wrap'>
						<img decoding="async" className='truck-image' src={MuckTruckClassic} alt='muck-truck-classic' />
						<div
							className='product-overlay'
							onClick={() => this.changeStep('/muck-truck')}
						>
							Muck - Truck klasik
						</div>
					</div>
					<div className='product-wrap'>
						<img decoding="async" className='truck-image' src={MuckTruckMax} alt='muck-truck-max' />
						<div
							className='product-overlay'
							onClick={() => this.changeStep('/max-truck')}
						>
							Muck - Truck MAX
						</div>
					</div>
					<div className='product-wrap'>
						<img decoding="async" className='truck-image' src={EMuckTruck} alt='e-muck-truck' />
						<div
							className='product-overlay'
							onClick={() => this.changeStep('/e-truck')}
						>
							E - Truck
						</div>
					</div>
					<div className='product-wrap'>
						<img decoding="async" className='truck-image' src={MuckTruckHMax} alt='muck-truck-h-max' />
						<div
							className='product-overlay'
							onClick={() => this.changeStep('/h-max')}
						>
							H - MAX Truck
						</div>
					</div>
					<div className='product-wrap'>
						PRÍSLUŠENSTVO
						<div
							className='product-overlay'
							onClick={() => this.changeStep('/prislusenstvo')}
						>

						</div>
					</div>
				</div>
				<div>
					<p>Od svojho vzniku v roku 1993 sa Muck-Truck®  s stal najobľúbenejším ručne vedeným mini prepravníkom  na svete.</p>
					<p className='text-align--justify'>Motorový vyklápací mini prepravník Muck Truck je navrhnutý a vyrobený v Veľká Británia a prináša zjavné výhody produktivity pre majiteľov rodinných domov, farmy,  mestské technické služby, záhradníctva, rekreačné strediská, stavebníctvo, drobné zemné práce a terénne úpravy, jazdecké centrá, nájomcov strojov a zariadení a mnoho ďalších využití. <b>ZABUDNITE NA FÚRIK</b>. Spoľahlivý komerčný motor Honda s výkonom 5,5 hp zabezpečuje pohon všetkých kolies, čím zabezpečuje maximálnu trakciu pri pohybe nákladu na mokrom, sypkom či nerovnom teréne.</p>
					<p>V najsilnejšej verzii odvezie až  450kg a pokojne s týmto nákladom bude stúpať aj do 30 ° svahu alebo po schodoch.</p>

					<h3>Bez ohľadu na to, čo potrebujete presunúť, previesť, premiestniť,  Muck-Truck® je odpoveď.</h3>

					<div style={{ textAlign: 'left' }}>
						<p>Stroje Muck – Truck sú postavené na prácu v náročných podmienkach, pomôžu vám so všetkým, nie len ťažkými prácami a v rôznom teréne.</p>
						<p>Muck-Truck®ale nie je len mocný a usilovný vyklápací štvorkolesový motorový fúrik.</p>
						<p>Muck – Truck je s radom vymeniteľných doplnkov mimoriadne všestranný a užitočný pomocník, ktorý si na seba veľmi rýchlo zarobí.</p>
						<p>Všetky modely Muck -Truck môžu byť v priebehu niekoľkých sekúnd vybavené vymeniteľným príslušenstvom.</p>
					</div>
				</div>
				<div className='row justifyContent--center'>
					{/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
					<iframe
						id="video"
						width="400"
						height="295"
						src="https://www.youtube.com/embed/RxGYgZaUk7g"
						allowFullScreen
					>
					</iframe>
					{/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
					<iframe
						id="video"
						width="400"
						height="295"
						src="https://www.youtube.com/embed/EX5rFfiliAk"
						allowFullScreen
					>
					</iframe>
					{/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
					<iframe
						id="video"
						width="400"
						height="295"
						src="https://www.youtube.com/embed/aUeTy6mw5iU"
						allowFullScreen
					>
					</iframe>
					{/* eslint-disable-next-line jsx-a11y/iframe-has-title */}
					<iframe
						id="video"
						width="400"
						height="295"
						src="https://www.youtube.com/embed/LBnHVRSaFu8"
						allowFullScreen
					>
					</iframe>
				</div>
			</div>
		);
	}
}

export default UsefulMachines;
